import { ContactsTableColumnStoredValue } from '@/types/storages';

function getDefaultContactsTableColumnStoredValue(): ContactsTableColumnStoredValue {
  return {
    width: 160,
    isShown: true,
  };
}

export default getDefaultContactsTableColumnStoredValue;
